<template>
  <div class="name-privacy-dialog">
    <w-dialog :dialog-show="settingShow" @handleClose="handleClose">
      <div slot="content" class="setting-content" @touchmove.prevent v-if="cvBase">
        <div class="header flex-between">
          <span>简历名称</span>
          <span class="iconfont iconx" @click="handleClose"/>
        </div>
        <input class="name" type="text" v-model="name">
        <div class="flex-start alert-msg" v-if="cvNameAlert">
          <img class="alert-img" src="https://files.wondercv.com/red-alert.png" alt="">
          <span class="alert-desc">{{errorMsg}}</span>
        </div>
        <p class="sub-title">选择模块内容，生成专业简历名称</p>
        <div class="select-list flex">
          <div @click="selectLabel(item)" class="select-item" :class="{'is-active': item.checked}"
               v-for="(item, index) in nameSelect" :key="index">{{ item.name }}
          </div>
        </div>
        <button class="bottom flex-center theme-button" @click="saveSetting">保存</button>
      </div>
    </w-dialog>
  </div>
</template>

<script>
	import WDialog from '@/components/global/w-dialog'
	import { mapState } from 'vuex'
	import { componentsMixin } from '@/assets/js/mixin/components'
	import { envMixin } from '@/assets/js/mixin/global'

	export default {
		props: {
			settingShow: {
				type: Boolean,
				default: false
			},
			cvData: {
				type: Object,
				default: () => {
					return {}
				}
			},
			type: {
				type: String,
				default: 'editor'
			}
		},
		mixins: [ componentsMixin, envMixin ],
		data () {
			return {
				cvNameAlert: false,
				errorMsg: '名称不能包含下列任何字符：+/\<>*?:|""、', // 修改简历名称时校验提示文案
				errorShow: false,
				nameSelect: [],
				cvInfo: {},
				name: ''
			}
		},
		components: {
			WDialog,
		},
		watch: {
			settingShow (val) {
				if (val) {
					this.name = this.cvBase.cv_name
					this.getNamePart()
				}
			}
		},
		computed: {
			...mapState('cv', [ 'cv' ]),
			cvBase () {
				return {
					token: this.cvData.token,
					cv_name: this.cvData.cv_name || ''
				}
			}
		},
		methods: {
			handleClose () {
				this.$emit('handleClose')
			},
			// 获取简历名称的label
			async getNamePart () {
				let res = await this.$api.cv.getCvNamePart(this.cvBase.token)
				if (res.code === 1000) {
          this.nameSelect = res.data.options
        }
			},
			// 选择简历名称的label
			selectLabel (item) {
				item.checked = !item.checked
				if (item.checked) {
					this.name += `_${ item.display_name }`
				} else {
					let name = new RegExp(`_${ item.display_name }|${ item.display_name }`, 'gi')
					this.name = this.name.replace(name, '')
				}
				if (this.name.substr(0, 1) === '_') this.name = this.name.slice(1)
				this.$forceUpdate()
			},
			// 保存设置名称
			async saveSetting (save) {
				let reg = /[+/\\<>*?:|"、]/im
				if (reg.test(this.name)) {
					this.cvNameAlert = true
					return
				}
				this._saveCvName()
			},
			// 更新简历名称的接口
			async _saveCvName () {
				let name_parts = this.nameSelect.filter(v => v.checked).map(v => v.value)
				let res = await this.$api.cv.updateCvDetail(this.cvBase.token, {
					operation_type: 'update_basic_info',
          basic_info: {
						cv_name: this.name,
            name_parts
          }
				})
				if (res.code === 1000) {
					this.handleClose()
					this.errorShow = false
					this.showToast('设置成功')
					this.$emit('refresh', res.data.basic_info.cv_name, 'changeName')
				}
			}
		}
	}
</script>
<style scoped lang="scss">
  @import '@/assets/scss/global/variable';
  .name-privacy-dialog {
    .setting-content {
      width: 90vw;
      border-radius: 10px;
      background-color: $color-light;
      padding: 32px 24px;
      .header {
        margin-bottom: 16px;
        font-size: $font-size-medium-x;
        span {
          color: $color-title;
          font-weight: 500;
        }
        .iconfont {
          font-size: 18px;
          color: #8c8c8c;
          font-weight: bold;
        }
      }
      .name {
        width: 100%;
        height: 36px;
        color: $color-title;
        margin-bottom: 14px;
        text-overflow: ellipsis;
      }
      .alert-msg {
        margin-bottom: 14px;
        .alert-img {
          width: 14px;
          margin-right: 5px;
        }
        .alert-desc {
          color: $color-title;
        }
      }
      .sub-title {
        color: $color-light-gray;
        margin-bottom: 10px;
      }
      .select-list {
        flex-wrap: wrap;
        .select-item {
          padding: 5px 10px;
          border: 1px solid #ededed;
          color: $color-light-gray;
          margin-right: 8px;
          margin-bottom: 10px;
          border-radius: 2px;
        }
        .is-active {
          border: 1px solid $color-theme;
          color: $color-theme;
        }
      }
      .extent-select {
        .extent-item {
          margin-bottom: 16px;
          .extent-left {
            width: 40%;
            .extent-name {
              color: $color-dark-gray;
              font-size: $font-size-medium;
              -webkit-appearance: none;
              width: 14px;
              height: 14px;
              border: 1px solid $color-theme !important;
              border-radius: 50%;
              margin-right: 12px;
              padding: 0 !important;
              display: flex;
              justify-content: center;
              align-items: center;
              &:checked:after {
                content: '';
                display: inline-block;
                width: 8px;
                height: 8px;
                border-radius: 50%;
                background-color: $color-theme;
              }
              &:disabled {
                border-color: $color-light-gray !important;
                &:after {
                  background-color: $color-light-gray;
                }
              }
            }
          }
          .desc {
            color: $color-light-gray;
            font-size: $font-size-medium;
          }
        }
        .privacy-extent {
          &:nth-child(2) {
            margin-bottom: 30px;
          }
          .private-title {
            color: $color-dark-gray;
            margin-bottom: 12px;
          }
        }
      }
      .cv-extent {
        margin-top: 18px;
        margin-bottom: 12px;
        color: $color-title;
        font-weight: 500;
      }
      .privacy-header {
        font-size: $font-size-medium-x;
        color: $color-title;
        margin-bottom: 30px;
        font-weight: 400;
        .iconfont {
          color: #8c8c8c;
          font-weight: bold;
          font-size: 20px;
        }
      }
      .normal-font {
        color: $color-title;
        font-size: $font-size-medium;
        span {
          font-weight: 400;
        }
      }
      .all-privacy-header {
        margin-top: 18px;
        margin-bottom: 12px;
      }
      .err-msg {
        margin-top: 24px;
        .error-title {
          margin-bottom: 8px;
          img {
            width: 14px;
            margin-right: 6px;
          }
        }
        p {
          color: $color-theme;
          line-height: 20px;
        }
      }
      .bottom {
        width: 100%;
        height: 38px;
        margin-top: 15px;
        border-radius: 2px;
        font-size: $font-size-medium-x;
      }
      .privacy-bottom {
        margin-top: 30px;
      }
    }
  }
</style>
